<template>
  <section class="page-section">
        <el-tabs class="no-margin-top" v-model="tabName" type="card" @tab-click="handleTabsChange">
          <el-tab-pane label="待预约" name="0"></el-tab-pane>
          <!-- <el-tab-pane label="待确认" name="1"></el-tab-pane> -->
        </el-tabs>

        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="专属管家：" prop="serviceUserName">
                <el-input v-model="filterForm.serviceUserName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="预约项目：" prop="name">
                <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="预约门店：" prop="shopName">
                <el-input v-model="filterForm.shopName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item :label="tabName == '0' ? '提交时间：' : '预约时间：'" prop="orderTime" class="auto-width">
                <el-date-picker v-model="filterForm.orderTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable">
            <el-table-column label="专属管家">
              <template slot-scope="scope">
                <span>{{ scope.row.serviceUserName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预约信息">
              <template slot-scope="scope">
                <span>{{ scope.row.customerName }}</span><br>
                <span>{{ scope.row.sex == 1 ? '男' : '女' }}，{{ scope.row.age }}</span>
                <span>{{ formatBirthday(scope.row.birthday) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.mobile }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预约项目" width="200">
              <template slot-scope="scope">
                <div class="goods-title">
                  <div class="thumb-wrap">
                    <img :src="scope.row.servicePic">
                  </div>
                  <p>{{ scope.row.serviceName }}</p>
                  <p>备注：{{ scope.row.serviceRemark || '-' }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="价格" sortable>
              <template slot-scope="scope">
                <p>￥{{ scope.row.price }}</p>
                <p>₩{{ scope.row.koreaPrice }}</p>
              </template>
            </el-table-column>
            <el-table-column label="预计到院时间">
              <template slot-scope="scope">
                <p>{{ COMMON.formatDate('2', '-', scope.row.orderTime) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="预约门店">
              <template slot-scope="scope">
                <span>{{ scope.row.shopName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="其他要求">
              <template slot-scope="scope">
                <span>{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <template v-if="tabName == '0'">
              <el-table-column label="提交时间">
                <template slot-scope="scope">
                  <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                </template>
              </el-table-column>
            </template>
            <!-- <el-table-column label="预约单状态">
              <template slot-scope="scope">
                <span>未设置</span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="pageNavigateToDetail(scope.row)">{{ tabName == '0' ? '完善' :
                  '修改' }}预约信息</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>

          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :page-size.sync="page.size" :current-page="page.current"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>
      </section>
</template>

<script>

import { COMMON, serviceOrdersList } from '../../../common/api'

export default {
  name: 'serviceReservationList',
  data() {
    return {
      COMMON,
      tabName: this.$route.query.tabname ? this.$route.query.tabname : '0', // 选项卡name
      filterForm: { // 筛选表单值
        serviceUserName: '',
        name: '',
        shopName: '',
        orderTime: []
      },
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },
      tableLoading: true,
      tableData: [] // 表格数据
    }
  },
  methods: {
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let time = this.filterForm.orderTime
      let param = {
        status: this.tabName,
        serviceUserName: this.filterForm.serviceUserName,
        "name": this.filterForm.name,
        'shopName': this.filterForm.shopName,
        startTime: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        endTime: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        "current": this.page.current,
        "size": this.page.size
      }

      serviceOrdersList(param).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;
          this.$nextTick(() => {
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.doLayout();
            }
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // this.filterFormReset('filterForm');
      this.$router.push({ path: '/service/reservation/list', query: { tabname: tab.name } });
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [pageNavigateToDetail description] 完善信息
     * @return {[type]}          [description]
     */
    pageNavigateToDetail: function (item) {
      this.$router.push({ path: '/service/reservation/add', query: { id: item.id, tabname: this.tabName } })
    },
    /**
     * [formatBirthday description] 格式化生日时间戳为 yyyy-mm-dd
     * @param  {[Number]} timestamp [description] 毫秒时间戳
     * @return {[String]}           [description] 格式化后的日期字符串
     */
    formatBirthday(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  },
  mounted() {
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    &+p {
      margin-top: 5px;
    }
  }
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.no-margin-top {
  flex-shrink: 0; // 如果有这个类名，也保证不压缩
}

// .table-region {
//   flex: 1; // 占用剩余高度
//   display: flex;
//   flex-direction: column;
//   overflow: hidden;
// }

.table-region {
  margin-bottom: 50px;

  :deep(.el-table) {
    flex: 1;

    &::before {
      height: 0;
    }

    // 强制修正单元格高度同步问题
    td {
      padding: 8px 0 !important;
    }

    .cell {
      line-height: normal !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

  // 修复固定列头部背景色不一致问题
  :deep(.el-table__fixed-right-patch) {
    background-color: #f6f7f9; // $colorTitleBg 的值
    border-bottom: none;
  }

  :deep(.el-table__fixed-right) {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }
}

.table-footer {
  flex-shrink: 0; // 分页区域不压缩，保持固定高度
}
</style>
